/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NearMissFilter } from './NearMissFilter';
import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';

export type NearMissViewRequest = {
    filter?: NearMissFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: NearMissViewRequest.exposeType;
}

export namespace NearMissViewRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
